"use client";

import { Field, FieldLabel } from "@ui/components/field";
import {
	InputGroup,
	InputGroupAddon,
	InputGroupButton,
	InputGroupInput,
} from "@ui/components/input-group";
import { CheckIcon, CopyIcon } from "lucide-react";
import { useId } from "react";
import { useCopy } from "./use-copy";

/** A read-only value with a copy button (webhook URLs and secrets). */
export function CopyField({
	label,
	value,
	onCopied,
	hideLabel,
}: {
	label: string;
	value: string;
	onCopied?: () => void;
	hideLabel?: boolean;
}) {
	const id = useId();
	// Copying by hand still works when the clipboard refuses: the field selects on focus.
	const { copied, copy } = useCopy(value, onCopied);
	return (
		<Field className="w-full">
			<FieldLabel
				htmlFor={id}
				className={hideLabel ? "sr-only" : undefined}
			>
				{label}
			</FieldLabel>
			<InputGroup>
				<InputGroupInput
					id={id}
					readOnly
					value={value}
					className="font-mono text-xs"
					onFocus={(event) => event.currentTarget.select()}
				/>
				<InputGroupAddon align="inline-end">
					<InputGroupButton
						size="icon-xs"
						aria-label={`Copy ${label.toLowerCase()}`}
						onClick={copy}
					>
						{copied ? <CheckIcon /> : <CopyIcon />}
					</InputGroupButton>
				</InputGroupAddon>
			</InputGroup>
		</Field>
	);
}
